import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const ArunIntro = () => {
  return (
    <section className="py-32 px-4 bg-background">
      <div className="container mx-auto max-w-4xl space-y-8">
        <div className="inline-block px-6 py-3 bg-accent/10 border-2 border-accent/20 rounded">
          <span className="text-sm font-bold tracking-[0.3em] text-accent uppercase">General Partner</span>
        </div>
        <h2 className="text-4xl md:text-6xl font-black leading-tight text-foreground">
          Arun Mohan. Founder turned investor.
        </h2>
        <p className="text-xl text-foreground leading-relaxed border-l-4 border-accent pl-6">
          21 years founding, scaling, and exiting enterprise software companies across San Francisco and
          Dubai: Adfolks to ZainTech (Zain Group), Actualize to CNTXT Tech, and AppsIntegra. Today he
          invests in AI infrastructure, sovereign &amp; physical AI, and works inside the portfolio as
          Investor &amp; Operating Partner.
        </p>
        <Button size="lg" variant="default" className="text-lg h-14 px-10 font-bold" asChild>
          <Link to="/arunmohan">Meet Arun →</Link>
        </Button>
      </div>
    </section>
  );
};

export default ArunIntro;